/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'add_item': 'Produktvorlage erstellen',
    'add_line_item_button': 'Zu {type} hinzufügen',
    'article_id': 'Artikelnummer',
    'confirm_checked_items_delete_body': 'Möchtest du die ausgewählten Produktvorlagen wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!',
    'confirm_checked_items_delete_title': 'Ausgewählte Produktvorlagen löschen?',
    'confirm_item_delete_body': 'Möchtest du die Produktvorlage "{item}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!',
    'confirm_item_delete_title': 'Produktvorlage löschen?',
    'default_quantity': 'Standard Stückzahl',
    'delete_line_item_group': 'Block löschen',
    'gross_placeholder': 'Gib bitte Netto und MwSt. an',
    'hour': 'Stunde|Stunden',
    'item': 'Produktvorlage | Produktvorlagen',
    'item_created': 'Die Produktvorlage wurde erfolgreich erstellt',
    'item_deleted': 'Produktvorlage gelöscht | Produktvorlagen gelöscht',
    'item_name': 'Produktname',
    'item_updated': 'Die Produktvorlage wurde erfolgreich aktuallisiert',
    'items_empty': 'Keine Produktvorlage vorhanden',
    'items_empty_create': 'Erstelle eine Produktvorlage indem du auf den untenstehenden Button drücken',
    'line_items_empty_text': 'Füge einen Posten hinzu',
    'new_line_item_button': 'Neuen Posten hinzufügen',
    'piece': 'Stück|Stück',
    'price': 'Preis',
    'price_gross': 'Preis (brutto)',
    'price_net': 'Preis (netto)',
    'quantity': 'Stückzahl',
    'unit_name': 'Einheit',
    'update_item': 'Produktvorlage bearbeiten',
    'update_line_item_button': 'Aktualisieren'
  },

  /* english */
  en: {
    'add_item': 'Create product template',
    'add_line_item_button': 'Add to {type}',
    'article_id': 'SKU',
    'confirm_checked_items_delete_body': 'Do you really want to delete the selectedproduct templates? This can not be undone!',
    'confirm_checked_items_delete_title': 'Delete selected product templates?',
    'confirm_item_delete_body': 'Do you really want to delete the product template "{item}"? This can not be undone!',
    'confirm_item_delete_title': 'Delete product template?',
    'default_quantity': 'Default quantity',
    'delete_line_item_group': 'Delete group',
    'gross_placeholder': 'Enter net and sales tax',
    'hour': 'Hour|Hours',
    'item': 'Product Template | Product Templates',
    'item_created': 'The product template has been created',
    'item_deleted': 'Product template deleted | Product templates deleted',
    'item_name': 'Item name',
    'item_updated': 'The product template was successfully updated',
    'items_empty': 'No product templates',
    'items_empty_create': 'Create an product template by clicking the button below',
    'line_items_empty_text': 'Add a line item',
    'new_line_item_button': 'Add new item',
    'piece': 'Piece|Pieces',
    'price': 'Price',
    'price_gross': 'Price (gross)',
    'price_net': 'Price (net)',
    'quantity': 'Quantity',
    'unit_name': 'Unit',
    'update_item': 'Edit product template',
    'update_line_item_button': 'Update'
  }
}
